export default __webpack_public_path__ + "asset/img/shop-logo/5~6af9fed3.png";